import Animation from 'features/Animation/ThankYou'

export default () =>
  <div className="my-2 article-width">
    <Animation />
  </div>
